export default "__VITE_ASSET__85a233ff__"